module.exports = __webpack_public_path__ + "static/media/WeddingReception.f660a017.png";